import { Controller } from 'stimulus';
import consumer from '../channels/consumer';

export default class extends Controller {
  static targets = ['counter'];

  initialize() {
    window.console.log('UnseenNotifications Controller Initialized!');
  }

  connect() {
    this.initializeConsumer();
    this.onInboxRowAdded = () => this.updateCounter();
    document.addEventListener('notifications:added', this.onInboxRowAdded);
    this.updateCounter();
  }

  disconnect() {
    document.removeEventListener('notifications:added', this.onInboxRowAdded);
  }

  get onInboxPage() {
    return $('[data-controller=notifications]').length > 0;
  }

  updateCounter() {
    if (this.onInboxPage) {
      // Behavior has to be different for the inbox page, because Notifications are
      // marked as :seen when they are added to the page, so they are not marked as
      // NEW (:seen == false) when the page is refreshed. Count the unseen rows on
      // the page; notifications_controller.js fires notifications:added once a
      // pinged row has actually been fetched and prepended (a 404, e.g. a notice
      // from another account, adds nothing and so counts nothing).
      const $unseen = $('.notification [data-target="notifications.unseen"]');
      this.updateCounterValue($unseen.length);
    } else {
      this.updateCounterFromServer();
    }
  }

  updateCounterFromServer() {
    $.ajax({
      method: 'GET',
      url: '/notifications?scope=unseen',
      data: { notification: { seen: true } },
      dataType: 'json',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      complete: (data) => {
        const count = data.responseJSON.length;
        this.updateCounterValue(count);
      },
    });
  }

  updateCounterValue(unseenCount) {
    if (unseenCount === 0) {
      this.$counter.addClass('hidden').hide();
    } else {
      this.$counter.text(unseenCount).removeClass('hidden').show();
    }
  }

  initializeConsumer() {
    consumer.subscriptions.create(
      {
        channel: 'NotificationsChannel',
        id: this.userId,
      },
      {
        received: (data) => {
          // Ignore pings for a notice in another of this user's accounts.
          if (data.account_id && this.accountId && data.account_id !== this.accountId) return;

          this.updateCounter();
        },
      },
    );
  }

  get $counter() {
    return $(this.counterTarget);
  }

  get userId() {
    return $(this.element).data('userId');
  }

  get accountId() {
    return $(this.element).data('accountId');
  }
}
